import { Skeleton } from 'antd';
import { ContentTopBar } from 'components'
import { UploadDetailsTable } from 'features/transaction_list/component/upload-deatils-list-tabel/upload-details-list-UploadDetails-table';
import { useGetUploadDetails } from 'features/transaction_list/use-cases/get-upload-details';
import { usePaginationParams } from 'hooks';
import { useEffect } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';

const UploadListDetails = () => {
    const location = useLocation();
    const { id } = useParams();
    const params1 = new URLSearchParams(location.search);

    const eventId = params1.get("eventId");
    const { params, updateParams } =
        usePaginationParams<any>({
            id: id,
            eventId: eventId,
            page: 1,
            size: 10,
        });

    useEffect(() => {
        updateParams({
            id: id,
            eventId: eventId,
        });
    }, [id, eventId]);

    const [searchParams] = useSearchParams();
    const origin = searchParams.get("origin") || "";
    const isBulkUpload =
        origin.toLowerCase() === "bulkupload"

    const originType = isBulkUpload ? "bulkupload" : "groupregistration";

    const { data, isFetching, refetch } = useGetUploadDetails(
        params,          
        originType,      
        { retry: false } 
    );

    const groupName = data?.items?.[0]?.bulk_upload_details?.group_name;

    const updatedTitle: string = isBulkUpload
        ? "Bulk Upload"
        : "Group Registration";

    const fullTitle = groupName
        ? `${groupName} - ${updatedTitle}`
        : `${updatedTitle} Participant List`;

    return (
        <>
            {isFetching || !data ? (
                <div style={{ padding: '16px 0 8px 0' }}>
                    <Skeleton.Input active={true} size="small" style={{ width: 280, height: 28, borderRadius: 4 }} />
                </div>
            ) : (
                <ContentTopBar
                    title={fullTitle}
                />
            )}

            <UploadDetailsTable
                data={data}
                isLoading={isFetching}
                tableParams={params}
                refetch={refetch}
                updateParams={updateParams}
                id={id}
            />
        </>
    )
}

export default UploadListDetails
